import {FlashcardAttribute} from 'shared/flashcard';

export interface FlashCardsContent {
    flashcards: FlashcardAttribute[];
}

export interface UpdatableFlashCardsContent {
    flashcards: (string|number)[];
}